import { useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from '../FirebaseAppContext';
import './DetailPages.css';

export default function CarDetail() {
  const { carId } = useParams<{ carId: string }>();
  const navigate = useNavigate();
  const { state, carOperations } = useAppContext();
  const car = state.cars.find(c => c.id === carId);

  if (!car) {
    return (
      <div className="detail-page">
        <div className="detail-card detail-list">
          <p>Car not found</p>
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/cars')}>Back to Cars</button>
        </div>
      </div>
    );
  }

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this car?')) {
      try {
        await carOperations.delete(car.id);
        navigate('/cars');
      } catch (err) {
        alert('Failed to delete car: ' + (err as Error).message);
      }
    }
  };

  return (
    <div className="detail-page">
      <div className="detail-header">
        <button type="button" className="btn btn-secondary" onClick={() => navigate('/cars')}>← Back</button>
        <div className="detail-heading">
          <h1 className="detail-title">{car.year} {car.make} {car.model}</h1>
          <span className="detail-subtitle">{car.licensePlate}</span>
        </div>
        <button type="button" className="btn btn-secondary" onClick={() => navigate(`/cars/${car.id}/edit`)}>Edit</button>
        <button type="button" className="btn btn-primary" onClick={handleDelete}>
          Delete
        </button>
      </div>

      <div className="detail-card detail-list">
        <div className="detail-item"><span className="detail-item-label">Make</span><span className="detail-item-value">{car.make}</span></div>
        <div className="detail-item"><span className="detail-item-label">Model</span><span className="detail-item-value">{car.model}</span></div>
        <div className="detail-item"><span className="detail-item-label">Year</span><span className="detail-item-value">{car.year}</span></div>
        <div className="detail-item"><span className="detail-item-label">Mileage</span><span className="detail-item-value">{car.mileage.toLocaleString()} km</span></div>
        <div className="detail-item"><span className="detail-item-label">Status</span><span className="detail-item-value">{car.status}</span></div>
        {car.vin && <div className="detail-item"><span className="detail-item-label">VIN</span><span className="detail-item-value">{car.vin}</span></div>}
        {car.fitnessExpirationDate && (
          <div className="detail-item"><span className="detail-item-label">Fitness Expiration</span><span className="detail-item-value">{new Date(car.fitnessExpirationDate).toLocaleDateString()}</span></div>
        )}
        {car.licenseExpirationDate && (
          <div className="detail-item"><span className="detail-item-label">License Expiration</span><span className="detail-item-value">{new Date(car.licenseExpirationDate).toLocaleDateString()}</span></div>
        )}
        {car.insuranceExpirationDate && (
          <div className="detail-item"><span className="detail-item-label">Insurance Expiration</span><span className="detail-item-value">{new Date(car.insuranceExpirationDate).toLocaleDateString()}</span></div>
        )}
      </div>
    </div>
  );
}

